<template>
  <div
    v-if="errorList.length > 0"
    class="rounded-md border-2 border-red-900 bg-red-300 flex justify-between items-start h-full w-full p-2"
  >
    <div
      class="flex items-center justify-center cursor-pointer h-8"
      @click="toggleRow()"
    >
      <div
        class="close-circle"
      />
    </div>
    <div class="w-full px-5 flex flex-col gap-2">
      <div class="h-8 flex flex-row items-center text-red-900 font-medium text-base">
        Your data has some invalid values. Please fix the data before submitting.
      </div>
      <transition name="expand">
        <div
          class="w-full flex flex-col gap-2"
          v-if="isExpanded"
        >
          <div
            v-for="(errorMessage,index) in errorList"
            :key="index"
            class="font-medium text-sm text-red-900"
            v-html="errorMessage"
          />
        </div>
      </transition>
    </div>
    <div
      class="flex items-center justify-center cursor-pointer h-8"
      @click="toggleRow()"
    >
      <div
        v-if="this.isExpanded"
        class="arrow-up"
      />
      <div
        v-else
        class="arrow-down"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isExpanded: false
    }
  },
  methods: {
    toggleRow() {
      this.isExpanded = !this.isExpanded
    }
  },
  watch: {
    errorList: {
      deep: true,
      handler(val) {
        if(val.length) {
          this.isExpanded = true
        }
      }
    }
  },
  props: {
    errorList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.arrowEdit {
  &.svg {
    fill: blue
  }
}
.arrow-down {
  width: 1.25rem;
  height: 1.25rem;
  background-color: #B01E47; /* warna fill */
  -webkit-mask: url('../../../../assets/shipo-icon-arrow-down.svg') no-repeat center;
  -webkit-mask-size: contain;
  mask: url('../../../../assets/shipo-icon-arrow-down.svg') no-repeat center;
  mask-size: contain;
}
.arrow-up {
  width: 1.25rem;
  height: 1.25rem;
  background-color: #B01E47; /* warna fill */
  -webkit-mask: url('../../../../assets/shipo-icon-arrow-up.svg') no-repeat center;
  -webkit-mask-size: contain;
  mask: url('../../../../assets/shipo-icon-arrow-up.svg') no-repeat center;
  mask-size: contain;
}
.close-circle {
  width: 2rem;
  height: 2rem;
  background-color: #B01E47; /* warna fill */
  -webkit-mask: url('../../../../assets/shipo-icon-close-circle.svg') no-repeat center;
  -webkit-mask-size: contain;
  mask: url('../../../../assets/shipo-icon-close-circle.svg') no-repeat center;
  mask-size: contain;
}

.expand-enter-active,
.expand-leave-active {
  transition: max-height 0.4s ease, opacity 0.3s ease;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}

.expand-enter-to,
.expand-leave {
  max-height: 500px; /* big enough to fit content */
  opacity: 1;
}
</style>